<template>
  <div class="ck_manage">
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 11px;
        margin-top: 30px;
        background-color: white;
        padding: 30px 0 27px 0;
      "
      class="headerSearch"
    >
      <div style="width: 90%; margin-left: auto; margin-right: auto">
        <el-form
          :model="searchForm"
          style="display: flex"
          class="demo-form-inline"
          label-width="90px"
          label-position="left"
        >
          <el-form-item label="仓库名称:">
            <el-input
              v-model="searchForm.ckmc"
              placeholder="请输入仓库名称"
            />
          </el-form-item>
          <el-form-item label="仓库类型:">
            <el-select v-model="searchForm.cklx" clearable placeholder="请选择">
              <el-option label="自有仓库" value="1" />
              <el-option label="租用仓库" value="2" />
              <el-option label="虚拟仓库" value="3" />
            </el-select>
          </el-form-item>
          <el-form-item label="仓库状态:">
            <el-select v-model="searchForm.ckzt" clearable placeholder="请选择">
              <el-option label="确认中" value="11" />
              <el-option label="启用中" value="12" />
              <el-option label="停用中" value="13" />
            </el-select>
          </el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            round
            class="sousuoButton"
            @click="sousuo"
          >搜索</el-button>
        </el-form>
      </div>
    </div>
    <div
      style="
        width: 95%;
        max-width: 1518px;
        margin: 0 auto;
        background-color: white;
        padding-top: 40px;
        padding-bottom: 17px;
        margin: 0 auto;
      "
    >
      <div class="tablemes">
        <el-table
          ref="cktable"
          v-loading="loading"
          :data="tableData"
          border
          :show-overflow-tooltip="true"
          :header-cell-style="{ background: '#F2F2F2' }"
          style="width: 100%"
          @select="select"
        >
          <el-table-column>
            <template slot="header">
              <el-button
                v-preventReClick
                type="primary"
                class="addButton"
                size="mini"
                icon="el-icon-plus"
                @click="addPupShow"
              >添加</el-button>
              <!-- <el-button
                class="deleteButton"
                size="mini"
                icon="el-icon-delete"
                   v-preventReClick   @click="Delete"
                >删除</el-button
              > -->
            </template>
            <el-table-column
              align="center"
              type="selection"
              width="55"
            />

            <el-table-column align="center" label="仓库名称">
              <template slot-scope="scope">
                <span>{{ scope.row.ckmc }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="仓库类型">
              <template slot-scope="scope">
                <span>{{ scope.row.cklxLabel }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              label="仓库地址"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.ckdz }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="最大仓储量">
              <template slot-scope="scope">
                <span>{{ scope.row.ccl }}({{ scope.row.cclDwLabel }})</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="保管员">
              <template slot-scope="scope">
                <span>{{ scope.row.ckbgy }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="120" label="保管员电话">
              <template slot-scope="scope">
                <span>{{ scope.row.ckbgyDh }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="监控" width="80">
              <template slot-scope="scope">
                <span>{{ scope.row.sfysxt == "Y" ? "有监控" : "无监控" }}</span>
              </template>
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              align="center"
              label="行政区划"
              width="200"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.provinceLabel }}/{{ scope.row.cityLabel }}/
                  {{ scope.row.countyLabel }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.zt == 11"> 确认中 </span>
                <span v-else-if="scope.row.zt == 14" style="color: red">
                  {{ scope.row.ztLabel }}
                </span>
                <el-switch
                  v-else
                  v-model="scope.row.zt"
                  :width="60"
                  active-value="12"
                  inactive-value="13"
                  :class="{
                    'switch-is-actived': scope.row.zt == '12',
                  }"
                  @change="ztTypeChange(scope.row.id, $event)"
                />
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="150px">
              <template slot-scope="scope">
                <el-button
                  v-preventReClick
                  size="mini"
                  type="primary"
                  style="background: #4170ff"
                  @click="handleQuery(scope.$index, scope.row)"
                >查看</el-button>
                <el-button
                  v-if="scope.row.zt == 12"
                  v-preventReClick
                  class="editButton"
                  size="mini"
                  type="warning"
                  @click="handleEdit(scope.$index, scope.row)"
                >编辑</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <el-pagination
          background
          layout="prev, pager,next,jumper,total,sizes"
          :page-sizes="[10, 20, 30]"
          :total="total"
          :page-size="pagesize"
          class="el-page"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>

    <el-dialog
      v-if="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="titleText"
      :visible.sync="dialogVisible"
      destroy-on-close
      center
      width="953px"
    >
      <ckdialog :leixing="leixing" :content="contentID" />
    </el-dialog>
  </div>
</template>
<script>
import Ckdialog from './ckdialog.vue'
import { getCkList, stopCkxx } from '@/assets/js/ckgl.js'
export default {
  components: { Ckdialog },
  filters: {},
  props: {},
  data() {
    return {
      model: true,
      loading: true,
      leixing: '',
      contentID: {},
      titleText: '',
      dialogVisible: false,
      table: [
        {
          key: 'ckmc',
          label: '仓库名称'
        },
        {
          key: 'cklxLabel',
          label: '仓库类型'
        },
        {
          key: 'ckdz',
          label: '仓库地址'
        },
        {
          key: 'ccl',
          label: '最大仓储量'
        },
        {
          key: 'ckbgy',
          label: '保管员'
        },
        {
          key: 'ckbgyDh',
          label: '保管员电话'
        },
        {
          key: 'sfysxt',
          label: '监控'
        },
        {
          key: 'stLabel',
          label: '行政区划'
        },
        {
          key: 'zt',
          label: '状态'
        }
      ],
      tableData: [], // 表格数据
      total: 0, // 总条数
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      searchForm: {
        ckmc: '',
        cklx: '',
        ckzt: ''
      },

      multipleSelection: []
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getCkList({
      page: this.currentPage,
      size: this.pagesize
    })
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    select(row) {
    },
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.getCkList({
        page: this.currentPage,
        size: this.pagesize
      })
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.getCkList({
        page: this.currentPage,
        size: this.pagesize
      })
    },
    toggleSelection(rows) {},
    handleSelectionChange(val) {},
    addPupShow() {
      this.contentID = ''
      this.leixing = 'add'
      this.titleText = '新增仓库'
      this.dialogVisible = true
    },
    handleEdit(index, row) {
      this.leixing = 'edit'
      this.titleText = '编辑仓库'
      this.dialogVisible = true
      this.contentID = row.id
    },
    handleQuery(index, row) {
      this.contentID = row.id
      this.titleText = '详细信息'
      this.dialogVisible = true
      this.leixing = 'query'
    },
    ztTypeChange(id, status) {
      stopCkxx({ id: id, status: status })
        .then((e) => {
          this.getCkList({
            page: this.currentPage,
            size: this.pagesize
          })
        })
        .catch(() => {
          this.getCkList({
            page: this.currentPage,
            size: this.pagesize
          })
        })
    },
    sousuo() {
      this.currentPage = 1
      this.getCkList({
        page: this.currentPage,
        size: this.pagesize,
        param: {
          ckmc: this.searchForm.ckmc,
          cklx: this.searchForm.cklx,
          zt: this.searchForm.ckzt
        }
      })
    },
    addOrUpdSave() {
      this.dialogVisible = false
      this.getCkList({
        page: this.currentPage,
        size: this.pagesize
      })
    },
    getCkList(data) {
      // 获取仓库列表
      getCkList(data).then((e) => {
        this.loading = false
        this.tableData = e.data.data.rows
        this.total = e.data.data.total
      })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-form-item__label {
  color: #333333;
}
.sousuoButton {
  width: 90px;
  height: 39px;
  background: #4170ff;
  // border-radius: 3px;
  border-color: #4170ff;
}
/deep/.el-form--inline .el-form-item__content {
  display: inline-block;
  vertical-align: middle !important;
}
/deep/.el-table--border {
  border-right: none;
  border-bottom: none;
  z-index: 0 !important;
}
.ck_manage {
  .headerSearch {
    // border: 1px solid red;
    display: flex;
    align-items: center;
    // height: 96px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 11px;
    // padding-left: 82px;
    box-shadow: 0px 1px 27px 3px rgba(0, 0, 0, 0.05);
    border-radius: 5px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    .el-form-item {
      height: 39px;
      margin-bottom: 0px;
      margin-right: 30px;
      &:last-child {
        width: 90px;
        height: 39px;
        /deep/ .el-button {
          width: 90px !important;
          height: 39px;
          border-radius: 3px;
        }
      }
    }
  }
  .el-form {
    margin-right: 40px;
    .el-form-item:nth-child(1) {
      margin-right: 30px;
    }
    .el-form-item:nth-child(2) {
      margin-right: 30px;
    }
    .el-form-item:nth-child(3) {
      margin-right: 30px;
    }
    .el-form-item {
      .el-form--inline .el-form-item__content {
        display: inline-block;
        // vertical-align: top;
        vertical-align: auto;
      }
    }
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #ebeef5;
    text-align: center;
  }
  .sousuo {
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    .sousuoButton {
      width: 90px;
      height: 39px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
  }
  .tablemes {
    width: 90%;
    margin: auto;
    max-width: 1375px;
    // margin-top: 21px;
    // margin-bottom: 57px;

    .el-pagination__total {
      margin-left: 8px;
    }
    .el-pagination {
      padding: 10px 0;

      border: 1px solid #ebeef5;
      border-top: 0;
    }
    .addButton {
      // width: 90px;
      // height: 36px;
      // padding: 0;
      color: #fff;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }

    .el-button--warning {
      color: #fff;
      width: 59px;
      height: 26px;
      background: #ffb50d;
      border-radius: 3px;
      border-color: #ffb50d;
    }
    .editButton {
      color: #fff;
      width: 59px;
      height: 26px;
      background: #4170ff;
      border-radius: 3px;
      border-color: #4170ff;
    }
    .el-pager {
      .number {
        background: #4170ff;
        border-color: #4170ff;
      }
    }
    /deep/.el-table-column--selection .cell {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .el-page {
    // width: 90px;
    // height: 39px;
    .el-pager {
      .active {
        background: #4170ff;
        border-radius: 3px;
        border-color: #4170ff;
      }
    }
  }
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 25px 50px 30px;
}
.el-switch {
  /deep/ .el-switch__core {
    &::before {
      content: "启用";
      color: white;
      position: absolute;
      // font-size: 14px;
      transform: scale(0.85);
      left: 20px;
    }
  }
  &.switch-is-actived {
    /deep/ .el-switch__core {
      &::before {
        content: "停用";
        left: 10px;
        transform: scale(0.85);
      }
    }
  }
}
/deep/.el-dialog__header {
  padding: 41px 53px 27px;
}
</style>
